import {useAppSelector} from "../../../store/hooks";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {isApplicationAbroad} from "../../utils/form/is_application_abroad";
import {useLeadData} from "../use_lead_data";
import {useLeadRequiredParams} from "../use_lead_required_params";

/**
 * @deprecated use useRecommendations hook instead
 */
export const useMultiLeadData = () => {
    const {vendorId, offerId, propertyId} = useLeadRequiredParams();
    const isAuthenticated = useIsAuthenticated();
    const applicationData = useLeadData({vendorId, offerId: offerId || undefined, propertyId: propertyId || undefined});
    const viewType = useAppSelector((store) => store.viewType.current);
    const originalApplicationGeoPoint = applicationData?.offer?.detail?.geo_point;
    const originalApplicationRegionCityID = applicationData?.offer?.detail?.region?.stats?.region_type_city?.id;
    const originalApplicationCountry = applicationData?.offer?.detail?.region.country;

    return {
        applicationData,
        isAuthenticated,
        viewType,
        originalApplicationGeoPoint,
        originalApplicationRegionCityID,
        originalApplicationCountry,
        isAbroadLead: isApplicationAbroad(originalApplicationCountry)
    };
};
import {useAppSelector} from "../../../store/hooks";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {isApplicationAbroad} from "../../utils/form/is_application_abroad";
import {useLeadData} from "../use_lead_data";
import {useLeadRequiredParams} from "../use_lead_required_params";

/**
 * @deprecated use useRecommendations hook instead
 */
export const useMultiLeadData = () => {
    const {vendorId, offerId, propertyId} = useLeadRequiredParams();
    const isAuthenticated = useIsAuthenticated();
    const applicationData = useLeadData({vendorId, offerId: offerId || undefined, propertyId: propertyId || undefined});
    const viewType = useAppSelector((store) => store.viewType.current);
    const originalApplicationGeoPoint = applicationData?.offer?.detail?.geo_point;
    const originalApplicationRegionCityID = applicationData?.offer?.detail?.region?.stats?.region_type_city?.id;
    const originalApplicationCountry = applicationData?.offer?.detail?.region.country;

    return {
        applicationData,
        isAuthenticated,
        viewType,
        originalApplicationGeoPoint,
        originalApplicationRegionCityID,
        originalApplicationCountry,
        isAbroadLead: isApplicationAbroad(originalApplicationCountry)
    };
};
